// extracted by mini-css-extract-plugin
export default {"card-content":"templates-market-parity-strategy-module__card-content"};